//global variables for path suffixes
export const cssGlobalFilenameSuffix = "-g";
export const cssMobileFilenameSuffix = "-m";
export const cssTabletFilenameSuffix = "-t";